import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { OficialAuxiliarOfflineAssertions } from '../../system/PlanillaPartidoOffline/OficialAuxiliarOfflineAssertions';
import { PlanillaPartidoOficialAuxiliar } from '../../system/PlanillaPartidoOficialAuxiliar/PlanillaPartidoOficialAuxiliar';

class OficialAuxiliarOfflineForm extends CustomForm {
  protected constructor(
    oao_id: string | null,
    oao_nro_doc: string,
    oao_nombre: string,
    oao_apellido: string,
    oao_orden: string
  ) {
    const oaoff = OficialAuxiliarOfflineAssertions.build();
    super('OficialAuxiliarOffline', oaoff);
    this.addInputAsserted('oao_id', oao_id);
    this.addInput('oao_nro_doc', oao_nro_doc);
    this.addInput('oao_nombre', oao_nombre);
    this.addInput('oao_apellido', oao_apellido);
    this.addInput('oao_orden', oao_orden);
  }

  private static build(
    oao_id: string | null,
    oao_nro_doc: string,
    oao_nombre: string,
    oao_apellido: string,
    oao_orden: string
  ) {
    return new this(oao_id, oao_nro_doc, oao_nombre, oao_apellido, oao_orden);
  }

  static initialize() {
    return this.build(null, '', '', '', '');
  }

  getIdInput() {
    return this.getInputByName('oao_id');
  }

  getNroDocInput() {
    return this.getInputByName('oao_nro_doc');
  }

  getNombreInput() {
    return this.getInputByName('oao_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('oao_apellido');
  }

  getOrdenInput() {
    return this.getInputByName('oao_orden');
  }

  toPlanillaPartidoOficialAuxiliar(eqId: number, ppId: number): PlanillaPartidoOficialAuxiliar {
    return PlanillaPartidoOficialAuxiliar.createFrom(
      this.getIdInput().getValue(),
      ppId,
      eqId,
      this.getNombreInput().getValue(),
      this.getApellidoInput().getValue(),
      this.getNroDocInput().getValue(),
      this.getOrdenInput().getValue(),
      false
    );
  }
}

export default OficialAuxiliarOfflineForm;
